// extracted by mini-css-extract-plugin
module.exports = {"p1bv2dwa":"p1bv2dwa"};